var React = require('react');

function Launch (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M6.353 18.125c-2.631.251-3.383 1.63-4.386.752C.84 17.75 3.095 14.116 5.225 11.61c0 1.003.126 1.88.376 2.883.25 1.253.502 2.506.752 3.633zM13.746 18.125c2.632.251 3.383 1.63 4.26.752 1.128-1.127-1.127-4.761-3.132-7.268-.125 1.003-.25 1.88-.376 2.883-.25 1.253-.501 2.506-.752 3.633z","clipRule":"evenodd","key":0}),React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M9.987.833c-6.516 5.263-4.01 13.158-3.133 17.293 2.256 1.128 4.135 1.128 6.391 0 .877-4.135 3.383-12.03-3.258-17.293zm0 7.895c1.378 0 2.506 1.127 2.506 2.506 0 1.378-1.128 2.506-2.506 2.506s-2.506-1.128-2.506-2.506c0-1.379 1.128-2.506 2.506-2.506z","clipRule":"evenodd","key":1})]);
}

Launch.defaultProps = {"width":"20","height":"20","fill":"none","viewBox":"0 0 20 20"};

module.exports = Launch;

Launch.default = Launch;
